<template>
    <div class="contact">
      <p>
        <span class="name">{{ preferences.author.name }}</span><br>
        {{ preferences.author.phone }}<br>
        {{ preferences.author.email }}
      </p>
    </div>
</template>

<script>
export default {
  name: 'Contact',
}
</script>
